export function isDate(date) {
	const DateExp = /^[1-2][0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
	if (DateExp.test(date)) {
		return new Date(date).getDate() === Number(date.substring(date.length - 2))
	} else {
		return false
	}
}
export function isMonth(date) {
	const DateExp = /^[1-2][0-9]{3}-(0[1-9]|1[0-2])$/
	if (DateExp.test(date)) {
		return new Date(date + '-01').getDate() === Number(1)
	} else {
		return false
	}
}
export function isDatetime(time) {
	if (typeof time === 'string') {
		const reg = /^(\d{1,4})(-|\/)(\d{2})\2(\d{1,2}) (\d{2}):(\d{2}):(\d{2})$/
		const r = time.match(reg)
		if (r == null) return false
		// @ts-expect-error ignore
		const d = new Date(r[1], r[3] - 1, r[4], r[5], r[6], r[7])
		return d.getFullYear() === Number(r[1]) && d.getMonth() + 1 === Number(r[3]) && d.getDate() === Number(r[4]) && d.getHours() === Number(r[5]) && d.getMinutes() === Number(r[6]) && d.getSeconds() === Number(r[7])
	} else {
		return true
	}
}
export function isAnyDate(val, type) {
	if ((isDate(val) && type === 'date') || (isMonth(val) && type === 'month') || (isDatetime(val) && type === 'datetime')) {
		return true
	} else {
		return false
	}
}

/**
 * 验证输入字符串是否符合指定的日期/时间格式
 *
 * 支持的格式占位符：
 * - yyyy: 4位年份 (如: 2026)
 * - MM: 2位月份 (01-12)
 * - dd: 2位日期 (01-31)
 * - HH: 24小时制小时 (00-23)
 * - mm: 分钟 (00-59)
 * - ss: 秒 (00-59)
 *
 * @param input - 要验证的输入字符串
 * @param format - 期望的格式模板，使用上述占位符
 * @returns boolean - 如果输入符合指定格式返回true，否则返回false
 *
 * @example
 * matchFormat('2026-01-28', 'yyyy-MM-dd') // true
 * matchFormat('2026/01/28', 'yyyy/MM/dd') // true
 * matchFormat('2026-1-28', 'yyyy-MM-dd') // false (月份和日期不是2位)
 * matchFormat('2026-01-28 14:30:00', 'yyyy-MM-dd HH:mm:ss') // true
 */
export function matchFormat(input, format) {
	// 构造正则表达式，匹配严格格式
	const formatRegex = {
		yyyy: '\\d{4}',
		MM: '(0[1-9]|1[0-2])',
		dd: '(0[1-9]|[12][0-9]|3[01])',
		HH: '([01][0-9]|2[0-3])',
		mm: '([0-5][0-9])',
		ss: '([0-5][0-9])'
	}

	// 将 format 转换为正则表达式
	let regexStr = format
	for (const key in formatRegex) {
		regexStr = regexStr.replace(key, formatRegex[key])
	}

	const regex = new RegExp(`^${regexStr}$`)
	return regex.test(input)
}

/**
 * 将Date对象格式化为指定格式的字符串
 *
 * 支持的格式占位符：
 * - y+ : 年份，y的数量决定显示的位数（如：yyyy=2026, yy=26）
 * - M+ : 月份（1-12）
 * - d+ : 日期（1-31）
 * - h+ : 小时（0-23）
 * - m+ : 分钟（0-59）
 * - s+ : 秒（0-59）
 * - q+ : 季度（1-4）
 * - S   : 毫秒
 *
 * 注意：对于M、d、h、m、s，如果格式中指定了多位（如MM、dd），则会自动补零
 *
 * @param date - 要格式化的Date对象
 * @param fmt - 格式模板字符串
 * @returns string - 格式化后的日期字符串
 *
 * @example
 * const date = new Date(2026, 0, 28, 14, 30, 45, 123)
 * format(date, 'yyyy-MM-dd') // "2026-01-28"
 * format(date, 'yyyy年MM月dd日 hh:mm:ss') // "2026年01月28日 14:30:45"
 * format(date, 'yy/M/d') // "26/1/28"
 * format(date, 'yyyy-MM-dd HH:mm:ss.S') // "2026-01-28 14:30:45.123"
 */
export function format(date: Date, fmt: string) {
	const o: any = {
		'M+': date.getMonth() + 1, // 月份
		'd+': date.getDate(), // 日
		'h+': date.getHours(), // 小时
		'm+': date.getMinutes(), // 分
		's+': date.getSeconds(), // 秒
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
		S: date.getMilliseconds() // 毫秒
	}
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	for (const k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
		}
	}
	return fmt
}
